export default {
  primary: '#297DAE',
  secondary: '#728793',
  success: '#31814C',
  info: '#2196F3',
  warning: '#F5A623',
  error: '#BF3C3C',
  accent: '#82B1FF',
};
